/*!
 * selection-controller v0.10.20 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
/* eslint-disable prefer-destructuring */
var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};
var defaultKeyGetter = function defaultKeyGetter(v) {
  return v;
};
var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};
var isValue = function isValue(value) {
  return !isUndefined(value) && value !== null;
};
function getKey(value) {
  var keyGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultKeyGetter;

  if (isValue(value)) {
    var key = keyGetter(value);

    if (!isUndefined(key)) {
      return key;
    }

    return value;
  }

  return null;
}

var getOption = function getOption(options, key, dflt) {
  var option = options.find(function (x) {
    return x.key === key;
  });
  return option && option.value || dflt;
};

var constructKeys = function constructKeys(options, keyGetter) {
  return options.map(function (x) {
    return getKey(x, keyGetter);
  });
};

function resolveStates(checkers, option, key, selected) {
  var states = {};
  var keys = Object.keys(checkers);

  for (var i = 0, length = keys.length; i < length; i++) {
    states[keys[i]] = checkers[keys[i]](option, key, selected);
  }

  return states;
}
function prepareOptions(options, value, keyGetter) {
  var stateCheckers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var keys = constructKeys(toArray(value), keyGetter);
  return options.map(function (option) {
    var key = getKey(option, keyGetter) || null;
    var selected = keys.findIndex(function (x) {
      return x === key;
    }) !== -1;
    var states = resolveStates(stateCheckers, option, key, selected);
    return Object.assign(states, {
      key: key,
      selected: selected,
      value: option
    });
  });
}
function prepareValue(options, value, keyGetter) {
  return toArray(value).map(function (v) {
    return getOption(options, getKey(v, keyGetter), v);
  });
}
function prepareData(elements, current, keyGetter) {
  var stateCheckers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var value = toArray(current);
  var options = prepareOptions(elements, value, keyGetter, stateCheckers);
  return {
    options: options,
    value: prepareValue(options, value, keyGetter)
  };
}
function updateValue(needle, current, keyGetter) {
  var multiple = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var value = needle;
  var key = getKey(needle, keyGetter);
  if (!isValue(key) && !Array.isArray(needle)) return [null];

  if (!Array.isArray(needle)) {
    if (!multiple || !needle) {
      value = [needle];
    } else {
      value = current.slice();
      var index = value.findIndex(function (x) {
        return getKey(x, keyGetter) === key;
      });

      if (index !== -1) {
        value.splice(index, 1);
      } else {
        value.push(needle);
      }

      value = value.filter(function (x) {
        return isValue(x) && isValue(getKey(x, keyGetter));
      });
    }
  }

  if (value.length === 0) {
    value = [null];
  }

  return value;
}
function resultValue(value) {
  var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return multiple ? value : value[0];
}
var lib = {
  resolveStates: resolveStates,
  prepareOptions: prepareOptions,
  prepareValue: prepareValue,
  prepareData: prepareData,
  updateValue: updateValue,
  resultValue: resultValue
};

export default lib;
export { defaultKeyGetter, getKey, isUndefined, isValue, prepareData, prepareOptions, prepareValue, resolveStates, resultValue, toArray, updateValue };
